import moment from 'moment';

export const now = () => {
  return moment().format();
};

export const cleanState = {
  guestSelectedStore: null,
  guestUserOrderMethod: null,
  guestUserAddress: null,
};

const initialState = {
  ...cleanState
};

export default (state = initialState, { type, value }) => {

  const valueByType = [
    { type: 'SET_GUEST_SELECTED_STORE', value: { ...state, guestSelectedStore: value }},
    { type: 'SET_GUEST_USER_ORDER_METHOD', value: { ...state, guestUserOrderMethod: value }},
    { type: 'SET_GUEST_USER_ADDRESS', value: { ...state, guestUserAddress: value }},
  ];

  const selectedType = valueByType.find(item => item.type === type);
  return selectedType ? selectedType.value : state;
};
